import React from 'react';
import Addicon from '../../media/add.png';
import { Image } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';

class View extends React.Component {

  state = {
    file: Addicon,
  }

  componentDidMount() {
    if (this.props.logo) {
      this.setState({
        file: this.props.logo,
      });
    }
    else {
      this.setState({
        file: Addicon,
      });
    }
  }

  handleFile = e => {
    if (!this.props.menuPermission.edit) {
      alert('Access Defined!!!');
      return;
    }
    this.updateLocalfile(e.target.files[0]);
    this.uploadimage(e.target.files[0])
  }

  uploadimage(file) {
    let context = this;
    let branchId = this.props.branchId;
    var formData = new FormData();
    formData.append('id', branchId);
    formData.append('file', file);
    $.ajax({
    type: 'POST',
    processData: false,
    contentType: false,
    data: formData,
    url: Server() + 'branchdetails/uploadimage.php',
    success: function(data) {
    },
    error: function(error) {
      alert('Try Again!!!')
    }
    });
  }

  updateLocalfile(value) {
    let reader  = new FileReader();
    let context = this;
    reader.addEventListener("load", function () {
      let out = reader.result;
      context.setState({
        file: out
      });
    }, false);
    if (value) {
      reader.readAsDataURL(value);
    }
  }

  render() {
    return (
      <div>
        <input id={this.props.branchId} type="file" onChange={this.handleFile} style={{display: 'none'}}/>
        <label htmlFor={this.props.branchId}>
          <Image src={this.state.file} size='small'
          style={{width: 80, height: 50, cursor: 'pointer'}}
          id='image' />
        </label>
      </div>
    );
  }
}

export default View;
